<template>
  <ActivityTemplate :is-status-claim="isFacebookIdExist">
    <template v-slot:icon>
      <div class="facebook mg-13">
        <b-icon
          icon="facebook"
          custom-size="mdi-23px"
          custom-class="connect-social-ic-facebook"
        />
      </div>
    </template>
    <template v-slot:title>
      <span class="head">{{ $t('profile.connect_with_facebook') }}</span>
    </template>
    <template v-slot:description>
      <p>
        {{ $t('profile.connect_facebook_acc') }}
      </p>
    </template>
    <template v-slot:button>
      <div v-if="!user.facebookId">
        <fb-signin-button
          :params="{ scope: 'email', return_scopes: true }"
          @success="(res) => {$emit('onSignInFacebookSuccess', res)}"
          @error="(e) => {$emit('onSignInFacebookError', e)}"
        >
          <div class="facebook">
            <span class="text">
              {{ $t('profile.connect_with_facebook') }}
            </span>
          </div>
        </fb-signin-button>
      </div>
      <div
        v-else
        class="facebook"
      >
        <span class="text-linked" >
          {{ user.facebookName || user.facebookEmail }}
        </span>
        <b-icon
          v-if="user.id && user.accountType !== 'FACEBOOK'"
          icon="link-off"
          custom-class="connect-social-ic-unlink"
          @click.native="$emit('onDisconnect')"
        />
      </div>
    </template>
  </ActivityTemplate>
</template>

<script>
import ActivityTemplate from '@/features/ActivityTemplate'

export default {
  name: 'ConnectWithFacebook',
  components: {
    ActivityTemplate
  },
  props: {
    canUnlink: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isFacebookIdExist () {
      return Boolean(this.user.facebookId)
    }
  }
}
</script>

<style lang="scss">
.connect-social-ic-facebook {
  color: #fff;
  padding: 1px 5px;
  background-color: #3b5998;
  border-radius: 50%;
}
.connect-social-ic-unlink {
  color: #7d7d7d;
  cursor: pointer;
}
.connect-social-ic-unlink:hover {
  cursor: pointer;
  color: #000;
}
</style>

<style lang="scss" scoped>
.facebook {
  span {
    float: left;
  }
  .text {
    margin: 0 5px 0 15px;
    vertical-align: top;
    font-size: 13px;
    color: #2193ff;
    font-weight: bold;
    text-decoration: underline;
  }
  .text:hover {
    color: #0079fd;
    cursor: pointer;
  }
  .text-linked {
    margin: 0 5px 0 15px;
    vertical-align: top;
    font-style: italic;
    font-size: 13px;
    text-decoration: underline;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 200px;
    overflow: hidden;
  }
}
.reward {
  font-size: 12px;
  font-weight: 400;
  width: 100%;
  float: left;
  span {
    vertical-align: middle;
  }
  &.claim {
    color: #7ed321;
  }
  &.wating {
    color: #afafaf;
  }
}
.head {
  float: left;
  width: 100%;
  font-size: 13px;
  font-weight: bold;
}
.mg-13 {
  margin: 0 0 13px 9px;
}

/* Mobile */
@media only screen and (max-width: 768px) {
  .reward {
    float: none;
    width: 100%;
    margin-top: 12px;
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConnectWithFacebook.vue